import {
  POSTHOG_TRACKING_EVENTS,
  POSTHOG_TRACKING_SOURCES,
} from '../constants';
import { CaptureTrackingEvent } from './types';

export const createWhatsAppEvents = (
  captureTrackingEvent: CaptureTrackingEvent
) => {
  const trackWhatsAppVerificationStarted = (isReplacement: boolean) =>
    captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.WHATSAPP_PHONE_VERIFICATION_STARTED,
      properties: {
        source: POSTHOG_TRACKING_SOURCES.SETTINGS,
        is_replacement: isReplacement,
      },
    });
  const trackWhatsAppPhoneConnected = (isReplacement: boolean) =>
    captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.WHATSAPP_PHONE_CONNECTED,
      properties: {
        source: POSTHOG_TRACKING_SOURCES.SETTINGS,
        is_replacement: isReplacement,
      },
    });
  const trackWhatsAppPhoneDisconnected = () =>
    captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.WHATSAPP_PHONE_DISCONNECTED,
      properties: { source: POSTHOG_TRACKING_SOURCES.SETTINGS },
    });

  return {
    trackWhatsAppVerificationStarted,
    trackWhatsAppPhoneConnected,
    trackWhatsAppPhoneDisconnected,
  };
};
